var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 7.75C7.41425 7.75 7.75004 7.41421 7.75004 7C7.75004 6.58579 7.41425 6.25 7.00004 6.25C6.58583 6.25 6.25004 6.58579 6.25004 7C6.25004 7.41421 6.58583 7.75 7.00004 7.75Z",
    fill: "#868F9E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.75C4.41421 7.75 4.75 7.41422 4.75 7C4.75 6.58579 4.41421 6.25 4 6.25C3.58579 6.25 3.25 6.58579 3.25 7C3.25 7.41422 3.58579 7.75 4 7.75Z",
    fill: "#868F9E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.75C10.4143 7.75 10.75 7.41421 10.75 7C10.75 6.58579 10.4143 6.25 10 6.25C9.58582 6.25 9.25004 6.58579 9.25004 7C9.25004 7.41421 9.58582 7.75 10 7.75Z",
    fill: "#868F9E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00004 10.75C7.41425 10.75 7.75004 10.4142 7.75004 10C7.75004 9.58578 7.41425 9.25 7.00004 9.25C6.58583 9.25 6.25004 9.58578 6.25004 10C6.25004 10.4142 6.58583 10.75 7.00004 10.75Z",
    fill: "#868F9E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.00004 10.75C4.41426 10.75 4.75004 10.4142 4.75004 10C4.75004 9.58578 4.41426 9.25 4.00004 9.25C3.58583 9.25 3.25005 9.58578 3.25005 10C3.25005 10.4142 3.58583 10.75 4.00004 10.75Z",
    fill: "#868F9E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.75C10.4143 10.75 10.75 10.4142 10.75 10C10.75 9.58578 10.4143 9.25 10 9.25C9.58582 9.25 9.25004 9.58578 9.25004 10C9.25004 10.4142 9.58582 10.75 10 10.75Z",
    fill: "#868F9E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1 4H13M2.5 1H11.5C11.8978 1 12.2793 1.15804 12.5606 1.43934C12.842 1.72064 13 2.10217 13 2.5V11.5C13 11.8978 12.842 12.2793 12.5606 12.5606C12.2793 12.842 11.8978 13 11.5 13H2.5C2.10217 13 1.72064 12.842 1.43934 12.5606C1.15804 12.2793 1 11.8978 1 11.5V2.5C1 2.10217 1.15804 1.72064 1.43934 1.43934C1.72064 1.15804 2.10217 1 2.5 1V1Z",
    stroke: "#868F9E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDate);
export default __webpack_public_path__ + "static/media/date.7224e06e8acf61e02c4b703eef25507f.svg";
export { ForwardRef as ReactComponent };